import { createVNode as a, mergeProps as e } from "vue";
import f from "../node_modules/@pf-ui/pf-icon-svg/es/asn/StaffUnknowTwotoneStandard.js";
import d from "../components/PfIcon.js";
const t = (o, n) => {
  const r = {
    ...o,
    ...n.attrs
  };
  return a(d, e(r, {
    icon: f
  }), null);
};
t.displayName = "StaffUnknowTwotoneStandard";
t.inheritAttrs = !1;
export {
  t as default
};
